module.exports = __webpack_public_path__ + "img/108.8c1b2d6c.png";